import styled, { css } from 'styled-components';

import { layout } from '../../../package.json';

export const ContainerPaymentData = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: row;

  margin-top: 50px;

  width: 100%;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid var(--primary);
`;

export const ContainerDataRequest = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;

  width: 100%;

  padding: 5px;
  border-radius: 8px;
`;

export const ContainerDataRequestItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;

  width: 100%;
  padding: 0.5rem 2%;

  span {
    width: 100%;
  }

  span + span {
    margin-left: 0.5rem;
  }
`;

export const ContainerDefaultPayCard = styled.div`
  width: 100%;
  padding: 10px;
  border-radius: 8px;

  border: 1px solid var(--primary);
  background-color: #672d903b;
`;

export const CardNumber = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;

  margin-right: 10px;
  span {
    margin-left: 10px;
  }
`;

export const CardName = styled.div`
  margin-right: 10px;
`;

export const ContainerCreate = styled.div`
  display: flex;
  width: 100%;
  gap: 1rem;
  @media (max-width: ${layout.desktop}) {
    flex-direction: column;
  }
`;

export const ContainerCardCredit = styled.div`
  width: 100%;
  h1 {
    color: #000;
  }
  > div {
    width: 100%;
    max-width: 23.12rem;

    > div {
      > div {
        background: var(--primary) !important;
      }
    }
  }

  @media (max-width: ${layout.desktop}) {
    > div {
      margin: 0 auto;
    }
  }
`;

export const ContainerFormCardCredit = styled.div`
  width: 100%;
`;

interface FormCardCreditBoxProps {
  justifyContent?: string;
  bDirectionColumn?: boolean;
}

export const FormCardCreditBox = styled.div<FormCardCreditBoxProps>`
  width: 100%;
  display: flex;
  ${props =>
    props.justifyContent &&
    `
  justify-content: ${props.justifyContent} ;
  margin-bottom: 30px;
  `}

  & + div {
    margin-top: 1rem;
    > div + div {
      margin-left: 1rem;
    }
  }

  button + div {
    margin-left: 1rem;
  }

  @media (max-width: ${layout.tablet}) {
    ${props =>
      props.bDirectionColumn &&
      css`
        flex-direction: column;
        div + div {
          margin-top: 1rem;
        }
      `}
    & + div {
      > div + div {
        margin-left: 0;
      }
    }
  }
`;

export const ContainerSectionFooter = styled.div`
  margin-top: 2rem;
  border-radius: 8px;
`;

export const ContainerButtons = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: stretch;

  > div + div {
    margin-left: 1rem;
  }
`;

interface ButtonProps {
  bgColor?: string;
  fgColor?: string;
  disabled?: boolean;
}

export const Button = styled.div<ButtonProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 300px;
  border-radius: 10px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  padding: 1rem 2%;

  ${props =>
    props.bgColor &&
    css`
      background-color: ${props.bgColor};
    `}

  span {
    text-align: center;
    font-size: 1.37rem;
    ${props =>
      props.fgColor &&
      css`
        color: ${props.fgColor};
      `}
    font-weight: 800;
  }

  ${props =>
    props.disabled === true &&
    css`
      opacity: 0.5;
      cursor: no-drop;
    `}

  @media (max-width: ${layout.tablet}) {
    span {
      font-size: 1.15rem;
    }
  }

  @media (max-width: ${layout.mobile}) {
    span {
      font-size: 1rem;
    }
  }
`;
